import type {SelectItem} from '@jetbrains/ring-ui/components/select/select'
import {useCallback, useMemo, useState} from 'react'

import {getBranchAutocompleteOptions} from './PipelineRepositoryBranchAutocomplete.utils'

const emptyBranchErrorMessage = 'Branch name should not be empty'

function usePipelineRepositoryBranchAutocomplete(
  options: SelectItem[],
  onChange: (value?: string) => void,
  value?: SelectItem | null,
) {
  const valueLabel = `${value?.label}`
  const [searchValue, setSearchValue] = useState<string>(valueLabel)
  const branchAutocompleteOptions = useMemo(
    () => getBranchAutocompleteOptions(options, searchValue),
    [options, searchValue],
  )
  const onChangeSelect = useCallback(
    (selectedItem?: SelectItem | null) => {
      const {key = '', label} = selectedItem ?? {}
      const isTypingEvent = typeof key === 'number'
      const name = isTypingEvent ? `${label}` : `${key}`

      onChange(name)
      setSearchValue(name)
    },
    [onChange],
  )
  const selectBlurHandler = () => {
    const selectedBranch = options.find(({key}) => key === searchValue)?.key?.toString()

    if (selectedBranch) {
      onChange(selectedBranch)
    }
  }
  const errorMessage = value?.label == null ? emptyBranchErrorMessage : null

  return {
    searchValue,
    errorMessage,
    onChangeSelect,
    selectBlurHandler,
    branchAutocompleteOptions,
  }
}

export default usePipelineRepositoryBranchAutocomplete
